/* -------------------------------------------------- */
/*                     Breakpoints                    */
/* -------------------------------------------------- */

export const breakpoints: any = {
  '@initial': 'mobile',
  '@micro': 'micro',
  '@sm': 'small',
  '@md': 'medium',
  '@lg': 'large',
}
